export default __webpack_public_path__ + "locales/fi/SmartBanner.json?hash=7a99e869aec0710a2a69e2eea4d7151c";